<template>
    <auth-layout-content :message="message" :title="$t('pages.auth.login.title')">
        <template #subtitle>
            <span>{{ $t('pages.auth.login.subtitle') }}</span>
            <router-link :to="{ name: RoutesEnum.AUTH.SIGNUP }">&nbsp;{{ $t('pages.auth.login.sign_up') }}</router-link>
        </template>

        <template #left-side>
            <login-form @failure="loginFailed($event)" @verificationEmailSent="verificationEmailSent"></login-form>
        </template>

        <template v-if="showGSignupButton()" #right-side>
            <google-signup-component></google-signup-component>
            <apple-signup-component></apple-signup-component>
        </template>
    </auth-layout-content>
</template>

<script>
    import AuthLayoutContent from 'components/layouts/layout-content/AuthLayoutContent'
    import LoginForm from 'components/forms/auth/LoginForm'
    import GoogleSignupComponent from 'components/page-elements/auth/google/GoogleSignupComponent'
    import AppleSignupComponent from 'components/page-elements/auth/apple/AppleSignupComponent'
    import RoutesEnum from 'enums/routes.enum'
    import Store from '~/store'
    import AuthService from 'services/AuthService'

    export default {
        components: { AuthLayoutContent, LoginForm, GoogleSignupComponent, AppleSignupComponent },

        data: () => ({ RoutesEnum, message: null }),

        methods: {
            showMessage(status, text, buttonLabel, buttonOnClickFunction) {
                this.message = {
                    text,
                    type: status,
                    buttonLabel,
                    buttonOnClickFunction,
                }
            },
            showSuccessMessage() {
                this.message = {
                    text: this.$t(`pages.auth.signup.messages.${this.invitationToken ? 'invite' : 'register'}_success`),
                    type: 'success',
                }
            },
            verificationEmailSent() {
                this.showMessage('success', 'pages.auth.login.messages.verification_email_sent')
            },

            loginFailed(event) {
                if (event.errorMessage.includes('BAD_CREDENTIALS')) {
                    this.showMessage('error', 'pages.auth.login.messages.invalid')
                } else if (event.errorMessage.includes('EMAIL_NOT_VERIFIED')) {
                    this.showMessage(
                        'error',
                        'pages.auth.login.messages.unverified',
                        'pages.auth.login.resend',
                        event.callbackResendVerificationEmailFunction,
                    )
                }
                Store.dispatch('configuration/setIsLoading', false)
            },

            showGSignupButton() {
                return !navigator.userAgent.includes('Instagram') && !navigator.userAgent.match(/FBAN|FBAV/i)
            },
        },

        mounted() {
            if (AuthService.isSubdomainActive()) {
                AuthService.reloadSubdomainCompany()
            }
            const text = this.$route.query.text
            const type = this.$route.query.type
            const fromSignUp = this.$route.query.fromSignUp
            if (text && type) {
                fromSignUp ? this.showMessage(type, text) : this.showMessage(type, this.$t(`pages.auth.login.messages.${text}`))
            }
            Store.dispatch('configuration/setIsLoading', false)
        },
    }
</script>
